module.exports = __webpack_public_path__ + "img/guest-logo.34a496f8.svg";